import React from "react";
import { Row } from "react-bootstrap";

const Registration = () => {
  return (
    <section className="vendor-categories-section py-5 bg-white register">
      <div className="container py-5">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center mb-5">
            <span className="works-subtitle">Registration</span>
            <h2 className="display-5 fw-bold mb-4">
              Employee Registration & Benefits
            </h2>
            <p className="lead">3-Step Registration Process</p>
          </div>
        </div>

        {/* Categories */}
        <Row className="g-4">
          {[
            {
              icon: "1",
              title: "Basic Info & Work Category Selection",
              subtitle: "Step 1",
            },
            {
              icon: "2",
              title: "ID & Verification Police Verification ",
              subtitle: "Step 2",
            },
            {
              icon: "3",
              title: "Enable Live Location & Add Bank Details ",
              subtitle: "Step 3",
            },
          ].map((item, index) => (
            <div key={index} className="col-md-4 col-lg-4">
              <div className="card h-100 text-center hover-card">
                <div className="card-body">
                  <div
                    className={`icon-wrapper text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center`}
                  >
                    {item.icon}
                  </div>
                  <h5>{item.title}</h5>
                  <span>{item.subtitle}</span>
                </div>
              </div>
            </div>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Registration;
